import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../styles/Header.css';

const Header = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    return (
        <header className="header">
            <div className="header-container">
                <div className="logo">
                    <Link to="/">
                        <img src="/logo/logo.jpeg" alt="MapLube Logo" className="logo-img" />
                        <span className="logo-text">MapLube</span>
                    </Link>
                </div>

                <nav className={`nav ${isMenuOpen ? 'nav-open' : ''}`}>
                    <ul className="nav-list">
                        <li><Link to="/" onClick={() => setIsMenuOpen(false)}>Home</Link></li>
                        <li><Link to="/about" onClick={() => setIsMenuOpen(false)}>About Us</Link></li>
                        <li><Link to="/products" onClick={() => setIsMenuOpen(false)}>Products</Link></li>
                        <li><Link to="/industries" onClick={() => setIsMenuOpen(false)}>Industries</Link></li>
                        <li><Link to="/quality-assurance" onClick={() => setIsMenuOpen(false)}>Quality</Link></li>
                        <li><Link to="/dealership" onClick={() => setIsMenuOpen(false)}>Dealership</Link></li>
                        <li><Link to="/blog" onClick={() => setIsMenuOpen(false)}>Blog</Link></li>
                        <li><Link to="/contact" onClick={() => setIsMenuOpen(false)}>Contact</Link></li>
                        <li><Link to="/faq" onClick={() => setIsMenuOpen(false)}>FAQ</Link></li>
                    </ul>
                </nav>

                <div className="mobile-menu-btn" onClick={toggleMenu}>
                    <span className={`hamburger ${isMenuOpen ? 'active' : ''}`}></span>
                </div>
            </div>
        </header>
    );
};

export default Header;
